import React from 'react';
import {Paper, Box, Container} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';

const styles = {
    root: {
        paddingTop: '1em',
        paddingRight: '2em',
        paddingLeft: '2em',
    },
};

const StaticForm = props => {
    return (
        <Container maxWidth='xs'>
            <Paper elevation={2}>
                <Box style={styles.root}>
                    <h1>{props.title}</h1>
                    {props.children}
                </Box>
            </Paper>
        </Container>
    );
};
export default withStyles(styles)(StaticForm);
